export default function upgradeNotice(message, next='/home') {
  this.$router.push({
      name: 'inapppurchase',
      query: { next: next},
  });
}
